import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {EmployeeGroupService} from 'app/blocks/service/api/employee-group.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IEmployeeGroup} from 'app/blocks/model/employee-group.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EmployeeGroup} from 'app/blocks/model/employee-group.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class EmployeeGroupResource extends AbstractEntityResource<IEmployeeGroup> {
    constructor(employeeGroupService: EmployeeGroupService, router: Router) {
        super(
            Resource.EMPLOYEE_GROUPS,
            employeeGroupService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.EMPLOYEE_GROUPS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.EMPLOYEE_GROUPS),
            (entity?) => new EmployeeGroup(entity),
            (entity) => entity.name,
            'group'
        );
    }
}
